import React, { useRef, useState, useEffect } from "react";
import Ordercard from "./Ordercard";
import "./Orderbody.css";
import { useSearchParams } from "react-router-dom";
import { ShowDialogForPayment } from "../eventComponent/EventTabs/showdialogforpayment";
import useMyOrders from "./useMyOrders";
import { useInvoiceActions } from "../../component/ServiceProvider/userInvoiceActions";
import MyButton1 from "../CustomComponents/MyButton1";

import {
  fetchTentCartAPI,
  deleteTentCartItemAPI,
  updateTentCartItemAPI,
  getTentHouseProviderServicesAPI,
  refundcateringfromcartapi,
  refundpreistfromcartapi,
  refundtentproviderfromcartapi
} from "../../Apiservices/Auth/cart/Addtocart_api";

import { useOrders } from "../../hooks/useOrders";

import { useDispatch, useSelector } from 'react-redux';




export const Orderbody = () => {

  const orderDataForDocument = useSelector((state) => state.cartbodyslice.order);


  const {
    fetchAllOrders,
    clearOrders
  } = useOrders();

  const [apiResponse, setApiResponse] = useState({ upcoming: [] });
  const [refundItems, setRefundItems] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [notFound, setNotFound] = useState(false);


  const { showPaymentInvoice, showPaymentReceipt } = useInvoiceActions();


  const eventRefs = useRef({});
  const [searchParams] = useSearchParams();
  const targetEventId = searchParams.get("eventId");


  const { orders, loading, error, refreshMyOrders } = useMyOrders();

  // Update apiResponse whenever orders change
  useEffect(() => {
    if (orders) setApiResponse(orders);
  }, [orders]);




  // Scroll to eventId from URL
  useEffect(() => {
    if (targetEventId) {
      if (eventRefs.current[targetEventId]) {
        eventRefs.current[targetEventId].scrollIntoView({ behavior: "smooth", block: "center" });
        setNotFound(false);
      } else {
        setNotFound(true);
      }
    }
  }, [targetEventId, apiResponse]);

  const handleSearch = () => {
    if (searchId && eventRefs.current[searchId]) {
      eventRefs.current[searchId].scrollIntoView({ behavior: "smooth" });
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  };



  const handle_cancelorders = async ({ eventId, provider_id, serviceType }) => {
    try {
      let response;
      if (serviceType === "Catering") response = await refundcateringfromcartapi(eventId, provider_id);
      else if (serviceType === "Tent House") response = await refundtentproviderfromcartapi(eventId, provider_id);
      else if (serviceType === "Priest") response = await refundpreistfromcartapi(eventId, provider_id);

      setRefundItems(
        [
          {
            type: serviceType,
            paid_amount: response?.paidAmount
          }
        ]
      );

      setShowDialog(true);

      // Refresh orders after refund
      refreshMyOrders();
    } catch (error) {
      console.error("Refund failed", error);
    }
  };

  const formatEventDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const datePart = date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" });
    const timePart = date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: true });
    return `${datePart} ${timePart}`;
  };

  const upcomingOrders = (apiResponse?.upcoming || []).map((ev) => ({ ...ev, category: "Upcoming" }));

  const renderOrders = () => {
    if (loading) return <div>Loading your orders...</div>;
    if (error) return <div className="error">{error}</div>;
    if (!upcomingOrders.length) return <div>No upcoming orders found.</div>;


    return upcomingOrders.map((event) => {

      const eventId = String(event.event_id);
      const matchedCart = orderDataForDocument?.[eventId];

      const eventCart = {
        event: {
          id: event.event_id,
          eventTitle: event.event_title,
          eventType: event.event_type ?? "",
          startDate: event.event_start_date,
          venue: event.venue
        },
        cateringProviders: matchedCart?.cateringData,
        tentProviders: matchedCart?.tentHouseData,
        priestProviders: matchedCart?.priestData
      }




      const orderData = {
        event: {
          id: event.event_id,
          eventTitle: event.event_title,
          eventType: event.event_type ?? "",
          startDate: event.event_start_date,
          venue: event.venue
        },
        cateringProviders: event.cateringproviderdata,
        tentProviders: event.tentproviderdata,
        priestProviders: event.priestdata
      }


      return (
        <div key={event.event_id} ref={(el) => (eventRefs.current[event.event_id] = el)} className="order-section">
          {/* header */}
          <div className="orders_headder">
            <div className="orders_headder_right">
              <span className="event_title">{event.event_title} on </span>
              <span className="event_venue">{event.venue}</span>
            </div>
            <div className="orders_headder_left">
              <div className="calendericonblock">
                <div className="calendericon">
                  <i className="pi pi-calendar"></i>
                  {formatEventDate(event.event_start_date)}
                </div>
              </div>
            </div>
          </div>

          {/* services */}
          {event.priestdata?.length > 0 && (
            <div className="insidecard">
              <span className="servicetitle">Priest</span>
              <div className="servicecards">
                <Ordercard serviceType="Priest" eventId={event.event_id} data={event.priestdata} onCancel={handle_cancelorders} />
              </div>
            </div>
          )}

          {event.tentproviderdata?.length > 0 && (
            <div className="insidecard">
              <span className="servicetitle">Tent house Rentals</span>
              <div className="servicecards">
                <Ordercard serviceType="Tent House" eventId={event.event_id} data={event.tentproviderdata} onCancel={handle_cancelorders} />
              </div>
            </div>
          )}

          {event.cateringproviderdata?.length > 0 && (
            <div className="insidecard">
              <span className="servicetitle">Catering Provider</span>
              <div className="servicecards">
                <Ordercard serviceType="Catering" eventId={event.event_id} data={event.cateringproviderdata} onCancel={handle_cancelorders} />
              </div>
            </div>
          )}

          <MyButton1 title={`View Invoice`} marginLeft="auto" marginBottom="10px" fontSize="14px" padding="10px" marginY="2px" disabled={false}
            method={() => showPaymentInvoice(eventCart)} />

          <MyButton1 title={`View Receipt`} marginLeft="auto" marginBottom="10px" fontSize="14px" padding="10px" marginY="2px" disabled={false}
            method={() => showPaymentReceipt(eventCart)} />
        </div>
      )
    });
  };

  return (
    <div className="Order-body">
      <div className="order-header">
        <span>Your Orders</span>
      </div>

      <div className="myorderswrap">
        {notFound && <div className="no-orders-message">No orders found for event ID {searchId || targetEventId}.</div>}
        {renderOrders()}
      </div>

      <ShowDialogForPayment refundItems={refundItems} showDialog={showDialog} setShowDialog={setShowDialog} />
    </div>
  );
};
